import { z } from 'zod';
/**
 * What state an agent draft is in. Drives `<DraftRow>` rendering on
 * the Today briefing and the rail of any surface that lists pending
 * agent work. Promoted here from a local TS union in `draft-row.tsx`
 * so server-side schemas (`BriefingDraft`) and the client surface
 * share one source of truth per the "closed string sets are enums"
 * invariant.
 */
export const DraftStatus = z.enum(['awaiting', 'sent', 'scheduled', 'acked']);
